export default "/images/zoom-out.svg?36859c57abf7fa996b6549604a1d8085";